module.exports = __webpack_public_path__ + "img/Manufacturing of edible goods.54b528c3.png";